import './ProjectPicker.scss';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { ChangeEvent, ReactElement } from 'react';
import { S_Checkbox } from '../../../../../../../design/inputs/checkbox/S_Checkbox';
import { doNothing } from '../../../../../../helpers/function.helpers';
import { QuestionWithAnswers } from '../../../../components/annotations/QuestionWithAnswers';
import { IQuestionModel } from '../../../../question.model';

interface IProps {
  id: string;
  name: string;
  count: number;
  checked: boolean;
  opened: boolean;
  questions: IQuestionModel[];
  onChange(id: string, value: boolean): void;
  onOpen(id: string, value: boolean): void;
}

export const ProjectPickerOption = observer((props: IProps): ReactElement => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    props.onChange(props.id, e.target.checked);
  };
  const handleOpen = (): void => {
    props.onOpen(props.id, !props.opened);
  };

  return (
    <>
      <div className='project-picker-options'>
        <S_Checkbox
          id={props.id}
          label={
            <div className='project-picker-option-label-wrapper'>
              <span className='project-picker-option-label'>{props.name}</span>
              <span>{`(${props.count})`}</span>
            </div>
          }
          checked={props.checked}
          onChange={handleChange}
        />
        <div className='angle-container'>
          {props.questions.length > 0 && (
            <FontAwesomeIcon
              icon={props.opened ? faAngleUp : faAngleDown}
              onClick={handleOpen}
            />
          )}
        </div>
      </div>
      {props.opened && props.questions.length > 0 && (
        <div className='project-picker-questions'>
          {props.questions.map((q) => (
            <QuestionWithAnswers
              key={q.id}
              question={q}
              disabled={true}
              isAttribute={false}
              onAnswered={doNothing}
            />
          ))}
        </div>
      )}
    </>
  );
});
